import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { handleApiError } from '../../requestHelpers/requestHelpers';

export const useUpdateLayout = (dashboardId: number) => {
  const { t } = useTranslation();
  return useMutation(
    (newLayout: any) => dataFetch.patch(
      `${DIGGER_API_SUFFIX}dashboard/${dashboardId}`,
      {
        layout: JSON.stringify(newLayout),
      },
    ),
    {
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};

export const useUpdateDashboard = () => {
  const { t } = useTranslation();
  return useMutation(
    (postRequest: any) => dataFetch[postRequest.id ? 'put' : 'post'](
      `${DIGGER_API_SUFFIX}dashboard${postRequest.id ? (`/${postRequest.id}`) : ''}`,
      {
        name: postRequest.name,
        isPrivate: postRequest.isPrivate,
        layout: postRequest.layout || '[]',
      },
    ),
    {
      onError: (error: any) => {
        error?.response?.data?.status?.message.map((message: string) => {
          closableEnqueueSnackbar(t(message), 'error');
          return error;
        });
      },
      onSuccess: () => {
        closableEnqueueSnackbar(t('dashboardUpdatedSuccessfully'), 'success');
      },
    },
  );
};

export const useSetSelectedDashboard = () => useMutation(
  (dashboardId: number) => dataFetch.patch(
    `${DIGGER_API_SUFFIX}user-settings/user`,
    {
      selectedDashboard: dashboardId,
    },
  ),
);

export const useDeleteDashboard = () => {
  const { t } = useTranslation();

  return useMutation(
    (id: number) => dataFetch.delete(
      `${DIGGER_API_SUFFIX}dashboard/${id}`,
    ),
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('dashboardDeletedSuccessfully'), 'success');
      },
      onError: () => {
        closableEnqueueSnackbar(t('somethingWentWrong'), 'error');
      },
    },
  );
};
